import type { MergeMenuItem } from '@getaccept/editor-lib';
import { MergeKey, MergeLabel } from '@getaccept/editor-lib/src/types/enums';

export const availableToggleableMergeTags: MergeMenuItem[] = [
  {
    label: MergeLabel.FullName,
    value: MergeKey.fullName,
  },
  {
    label: MergeLabel.Title,
    value: MergeKey.title,
  },
  {
    label: MergeLabel.Email,
    value: MergeKey.email,
  },
  {
    label: MergeLabel.CompanyName,
    value: MergeKey.companyName,
  },
  {
    label: MergeLabel.OrganisationNumber,
    value: MergeKey.companyNumber,
  },
  {
    label: MergeLabel.SignDate,
    value: MergeKey.signDate,
  },
];
